<script>


export default {
  name: 'Title',
  props: {
    step: {
      type: [Number, String],
      required: true
    }
  }
}
</script>

<template>
    <div class="title">
      <div class="step">
        <span class="step-label">Шаг</span>
        <span class="number-step">{{step}}</span>
      </div>
      <div class="text">
        <slot></slot>
      </div>
    </div>
</template>

<style lang="scss" scoped>
  @import '/src/style/variable';

  .title {
    font-family: $font-family;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    align-content: center;
    margin: 20px 0;
    @media #{$media-575}{
      margin: 0;
    }
    .text {
      color: $color-blue;
      font-weight: 600;
      font-size: 25px;
      line-height: 100%;
      @media #{$media-820}{
        font-size: 18px;
        width: 70%;
      }
    }
    .step {
      $font-size: 14px;
      display: inline-flex;
      align-items: center;
      background-color: $color-orange;
      padding: 12px 20px;
      border-radius: 99px;
      margin-right: 20px;
      max-height: $font-size;
      box-sizing: content-box;
      @media #{$media-820}{
        padding: 9px 10px;
        margin-right: 15px;
      }
      @media #{$media-575}{
        min-width: 46px;
      }
      .step-label {
        margin-right: 12px;
        color: $color-white;
        font-weight: 500;
        font-size: $font-size;
        text-align: center;
        line-height: 100%;
        @media #{$media-820}{
          margin-right: 5px;
        }
      }
      .number-step {
        font-weight: 600;
        color: $color-dark-blue;
        font-size: 57.273px;
        transform: rotate(12.19deg);
        margin-bottom: 17px;
        margin-right: -15px;
        @media #{$media-820}{
          font-size: 40px;
          margin-bottom: 13px;
          margin-right: -10px;
        }
      }
    }
  }
</style>